import React from "react";
import { Link, useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { Box, Checkbox, MenuItem, FormControl, Select } from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { toast } from "react-toastify";
import { getAllVisits } from "../../../../services/visits";
import {
  getAllTreatments,
  getAllTreatmentsService,
} from "../../../../services/treatments";
import { useCallbackPrompt } from "../../../../hooks/useCallbackPrompt";
import DialogBox from "../../../../components/DialogBox";
import { createNewDispensation } from "../../../../services/dispensations";

import "../StudySetup.css";

const CreateDispensation = () => {
  const navigate = useNavigate();

  const [load, setLoad] = React.useState(false);

  const [showDialog, setShowDialog] = React.useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const [visitsData, setVisitsData] = React.useState([]);
  const [treatmentData, setTreatmentData] = React.useState([]);

  const createDispensationSchema = yup.object().shape({
    visitId: yup.string().required("This field is required"),
    treatmentId: yup.string().required("This field is required"),
    isRequired: yup.bool().oneOf([true, false], "Window override is required"),
  });

  const {
    register,
    setValue,
    reset,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(createDispensationSchema),
  });

  const notify = () =>
    toast.success("Dispensation Created Successfully", {
      toastId: "form-creation",
    });

  const requestFailed = (msg) =>
    toast.error(`${msg}`, {
      toastId: "requestFailed",
    });

  const onSubmit = async (data) => {
    try {
      setLoad(true);
      setShowDialog(false);
      data.notes = "note";
      const res = await createNewDispensation(data);
      if (res.status) {
        setLoad(false);
        notify();
        reset();
        navigate("/study-management/dispensations");
      }
    } catch (err) {
      setLoad(false);
      setShowDialog(false);
      console.log("Error: ", err.message);
      requestFailed(err.message);
    }
  };

  const fetchAllVisitsData = async () => {
    try {
      const res = await getAllVisits();
      if (res.status) {
        setVisitsData(res.data?.result);
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  const fetchAllTreatmentsData = async () => {
    try {
      const res = await getAllTreatmentsService();
      if (res.status) {
        setTreatmentData(res.data?.result);
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  React.useState(() => {
    fetchAllVisitsData();
    fetchAllTreatmentsData();
  }, []);

  const handleBack = (e) => {
    e.preventDefault();
    if (isDirty) {
      const confirm = window?.confirm(
        "You have unsaved changes,Are you sure want to leave ?"
      );
      if (confirm) {
        navigate("/study-management/dispensations");
      } else {
        e.preventDefault();
      }
    } else {
      navigate("/study-management/dispensations");
    }
  };

  const handleBackMain = (e) => {
    e.preventDefault();
    if (isDirty) {
      const confirm = window?.confirm(
        "You have unsaved changes,Are you sure want to leave ?"
      );
      if (confirm) {
        navigate("/study-management");
      } else {
        e.preventDefault();
      }
    } else {
      navigate("/study-management");
    }
  };

  const rowStyles = {
    marginTop: "2%",
  };

  const labelStyles = {
    display: "flex",
    alignItems: "center",
    height: "30px",
  };

  const textBoxStyles = {
    fontSize: 15,
    width: "400px",
    height: "10px",
  };

  const selectStyles = {
    width: 530,
    marginTop: 1,
  };

  return (
    <>
      {load ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <BeatLoader color="#3661eb" />
          </div>
        </>
      ) : (
        <>
          <div className="content-body">
            <p className="study-management-link" style={{ fontWeight: "600" }}>
              <div
                onClick={(e) => {
                  handleBackMain(e);
                }}
              >
                <Link>Manage Your Study</Link>
              </div>{" "}
              |{" "}
              <div
                onClick={(e) => {
                  handleBack(e);
                }}
              >
                <Link>Dispensations</Link>
              </div>{" "}
              |{" "}
              <Link to="/study-management/dispensations/create">
                Create Dispensations
              </Link>
              -{" "}
              <b style={{ color: "gray" }}>
                {sessionStorage?.getItem("studyName")}
              </b>
            </p>

            <Row style={rowStyles}>
              <Col md={6}>
                <div className="study-management-head-start">
                  <p className="study-management-heading">
                    Create Dispensations
                  </p>
                </div>
              </Col>
              <Col md={6}></Col>
            </Row>

            <div>
              <DialogBox
                showDialog={showPrompt}
                confirmNavigation={confirmNavigation}
                cancelNavigation={cancelNavigation}
              />
            </div>

            <Box
              component="form"
              onSubmit={handleSubmit(onSubmit)}
              sx={{ height: "auto", width: "100%" }}
              autoComplete="off"
            >
              <div className="createDispensationFormBody">
                <div className="createDispensationInput">
                  <p style={labelStyles}>
                    Visit {/* {errors.visitId?.message ? ( */}
                    <span className="error-highlight">*</span>
                    {/* ) : (
                    <></>
                  )} */}
                  </p>
                  <FormControl sx={selectStyles}>
                    <Select
                      name="visitId"
                      defaultValue={""}
                      inputProps={{
                        style: textBoxStyles,
                        "aria-label": "Without label",
                        className: "custom-input-class",
                      }}
                      {...register("visitId", {
                        onChange: (e) => {
                          setValue("visitId", e.target.value, {
                            shouldValidate: true,
                          });
                          setShowDialog(true);
                        },
                      })}
                    >
                      <MenuItem value="">
                        <em value={"-1"}>None</em>
                      </MenuItem>
                      {visitsData.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.visitId && (
                      <>
                        <div className="createCaregiverFlexEnd">
                          <div className="createCaregiverError">
                            <span className="error-text">
                              {errors.visitId.message}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    {/* {errors.visitId && (
                    <p className="error-text">{errors.visitId.message}</p>
                  )} */}
                  </FormControl>
                </div>

                <div className="createDispensationInput">
                  <p style={labelStyles}>
                    Treatment {/* {errors.treatmentId?.message ? ( */}
                    <span className="error-highlight">*</span>
                    {/* ) : (
                    <></>
                  )} */}
                  </p>
                  <FormControl sx={selectStyles}>
                    <Select
                      name="treatmentId"
                      defaultValue={""}
                      inputProps={{
                        style: textBoxStyles,
                        "aria-label": "Without label",
                        className: "custom-input-class",
                      }}
                      {...register("treatmentId", {
                        onChange: (e) => {
                          setValue("treatmentId", e.target.value, {
                            shouldValidate: true,
                          });
                          setShowDialog(true);
                        },
                      })}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {treatmentData.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.description}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.treatmentId && (
                      <>
                        <div className="createCaregiverFlexEnd">
                          <div className="createCaregiverError">
                            <span className="error-text">
                              {errors.treatmentId.message}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    {/* {errors.treatmentId && (
                    <p className="error-text">{errors.treatmentId.message}</p>
                  )} */}
                  </FormControl>
                </div>

                <div className="createVisitCheckbox">
                  <p>Is Required</p>
                  <Checkbox
                    style={{ fontSize: "14px" }}
                    inputProps={{ "aria-label": "controlled" }}
                    {...register("isRequired", {
                      onChange: (e) => {
                        setShowDialog(true);
                      },
                    })}
                  />
                  {errors.isRequired && (
                    <p
                      style={{
                        marginTop: "10px",
                        color: "blue",
                      }}
                    >
                      {errors.isRequired.message}
                    </p>
                  )}
                </div>
              </div>

              <Row style={rowStyles}>
                <Col md={8}></Col>
                <Col md={2}>
                  <div className="study-management-head-end">
                    <button
                      onClick={(e) => {
                        handleBack(e);
                      }}
                      className="study-management-cancel-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="study-management-head-end">
                    {/* <Link to="/study-management-builder"> */}
                    <button
                      type="submit"
                      className="study-management-create-btn-md"
                    >
                      Create
                    </button>
                  </div>
                </Col>
              </Row>
            </Box>
          </div>
        </>
      )}
    </>
  );
};

export default CreateDispensation;
